import { withStyles } from "@mui/styles"
import { FormattedMessage, injectIntl } from "react-intl"
import { Styles } from "src/styles/material-styles"
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Pagination, TextField, Typography } from "@mui/material";
import LlmDocumentArticlesList from "./llmdocumentarticleslist";
import AvailableArticles from "./availablearticles";
import { useState } from "react";
import Api from "src/services/api";
import { PapiroConsole } from "src/utils/papiroConsole";
import { Clear, Close, Search, ZoomIn } from "@mui/icons-material";
import SimpleSelect from 'src/components/select/simple-search';

const LlmArticles = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading, loading, hirerid, match } = props

    const [openArticlesDialog, setOpenArticlesDialog] = useState(false)
    const [articles, setArticles] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [pageStart, setPageStart] = useState(1)
    const [pageEnd, setPageEnd] = useState(10)
    const [selected, setSelected] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [filterSelected, setFilterSelected] = useState('id')
    const [search, setSearch] = useState('')

    const filters = [
        { name: intl.formatMessage({ id: "author" }), id: "createduser" },
        { name: intl.formatMessage({ id: "description" }), id: "description" },
        { name: intl.formatMessage({ id: "title" }), id: "title" },
        { name: intl.formatMessage({ id: "id" }), id: "id" },
    ]

    const setPaginationAvailable = (count, page) => {
        setTotalPages(Math.ceil(count / 10))
        const start = count > 0 ? (page - 1) * 10 + 1 : 0
        setPageStart(start)
        setPageEnd(Math.min(start + 9, count))
    }

    const onChangePaginateAvailable = (event, value) => {
        setPage(value)
        getAvaliableArticles(value)
    }

    const getAvaliableArticles = async (page = 1) => {
        let url = `/articles/paginate?page=${page}`;

        if (filterSelected != '' && search != '') {
            url += `&search=${search}&field=${filterSelected}`
        }
        url += `&llmdocument=false`
        onLoading(true)
        await Api.get(url)
            .then((response) => {
                if (response) {
                    setTotal(response.data?.count)
                    setPaginationAvailable(response.data?.count, page)
                    setArticles(response.data.data)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const openArticles = async () => {
        await getAvaliableArticles()
        setOpenArticlesDialog(true)
    }

    const onSelect = (id) => {
        if (selected.indexOf(id) > -1) {
            setSelected(selected.filter(i => i != id))
        } else {
            setSelected([...selected, id])
        }
    }

    const onSave = async () => {
        onLoading(true)
        const apiurl = Api.apiurlbase().replace("https", '').replace("http", '').replace("://", "").replace('/', '')
        let data = new FormData()
        data.append('hirerid', hirerid)
        data.append('llmId', llm.id)
        data.append('urlapi', apiurl)
        PapiroConsole.log("selected knowledge bases")
        PapiroConsole.log(selected)
        const relationids = selected.join(",")

        data.append('relationids', relationids)

        await Api.post(`/llmdocumentarticles`, data)
            .then(async (response) => {
                onShowNotification(intl.formatMessage({ id: "add.success" }), 'success')
                if (response)
                    await setRefresh(!refresh)
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.uploading.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        setSelected([])
        onLoading(false)
        setOpenArticlesDialog(false)
    }

    const clearFields = async () => {
        setSearch('')
        setFilterSelected('id')
        setPage(1)
        getAvaliableArticles(1)
    }

    const handleKeyDown = (event) => {
        // Verifica se a tecla pressionada foi a 'Enter'
        if (event.key === 'Enter') {
            // Chama a mesma função que o botão de busca já chama
            getAvaliableArticles()
        }
    }

    const onFieldChange = (statename, value) => {
        setFilterSelected(value)
        setPage(1)
    }

    const changeValues = (event) => {
        setSearch(event.target.value)
    }

    return (
        <Grid container gap={2} paddingTop={2}>
            <Grid item xs={12}>
                <Button variant="contained" color="primary" onClick={openArticles} style={{ marginBottom: 12 }} minWidth={'25%'}>
                    {intl.formatMessage({ id: "add" })}
                </Button>
            </Grid>

            <LlmDocumentArticlesList
                classes={classes}
                intl={intl}
                llm={llm}
                onShowNotification={onShowNotification}
                onLoading={onLoading}
                loading={loading}
                hirerid={hirerid}
                articles={articles}
                refresh={refresh}
                match={match}
            />

            <Dialog
                open={openArticlesDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={_ => setOpenArticlesDialog(false)}
                maxWidth="xl"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                        },
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title">{intl.formatMessage({ id: "articles" })}</DialogTitle>
                <IconButton
                    aria-label="fechar"
                    onClick={() => setOpenArticlesDialog(false)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent >
                    <DialogContentText>
                        <Grid item xs={12} sm={12}>
                            <Card className="background-title-search">
                                <CardContent>
                                    <Grid container spacing={1} alignItems="flex-end">
                                        <Grid item xs={12} md={6}>
                                            <Typography variant="h5">
                                                {intl.formatMessage({ id: "news" })}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <SimpleSelect
                                                label={intl.formatMessage({ id: "field" })}
                                                options={filters}
                                                stateName='filter'
                                                changeSelect={onFieldChange}
                                                selected={filterSelected} />
                                        </Grid>
                                        <Grid item>
                                            <Search />
                                        </Grid>
                                        <Grid item >
                                            <TextField type="text"
                                                name="search"
                                                value={search}
                                                placeholder={intl.formatMessage({ id: "search" })}
                                                onChange={changeValues}
                                                onKeyDown={handleKeyDown} />
                                            <Button
                                                variant='contained'
                                                color='secondary'
                                                size='large'
                                                className={classes.button}
                                                style={{ marginRight: 4, marginLeft: 8 }}
                                                onClick={_ => getAvaliableArticles()}
                                            >
                                                <Search />
                                            </Button>

                                            <Button
                                                variant='contained'
                                                color='primary'
                                                size='large'
                                                onClick={clearFields}
                                                className={classes.button}
                                            >
                                                <Clear />
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </DialogContentText>
                    <AvailableArticles
                        classes={classes}
                        intl={intl}
                        llm={llm}
                        onShowNotification={onShowNotification}
                        onLoading={onLoading}
                        loading={loading}
                        hirerid={hirerid}
                        articles={articles}
                        selected={selected}
                        setSelected={(id) => onSelect(id)}
                        match={match}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                        <Grid item xs={12} md={3}>
                            <Pagination count={totalPages} page={page} onChange={onChangePaginateAvailable} />
                        </Grid>
                        <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                            {pageStart} {<FormattedMessage id="to" />} {pageEnd} {<FormattedMessage id="of" />} {total} {<FormattedMessage id="register" />}
                        </Grid>
                        <Grid item xs={12} md={4} />
                        <Grid item xs={12} md={1}>
                            <Button onClick={_ => setOpenArticlesDialog(false)} color="secondary">
                                {intl.formatMessage({ id: "close" })}
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Button onClick={onSave} color="primary" variant="contained">
                                {intl.formatMessage({ id: "save" })}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default injectIntl(withStyles(Styles)(LlmArticles))